import { NOTICE_EN } from "./legal-notice-words-en.ts";
import { PRIVACY_EN } from "./legal-privacy-words-en.ts";
import { TERMS_EN } from "./legal-terms-words-en.ts";
import type { LegalWords } from "./legal-words.ts";

// Every legal word in English, the version that controls (ADR-024, D701).

export const LEGAL_EN: LegalWords = {
  chrome: {
    footerTitle: "Legal",
    terms: "Terms",
    privacy: "Privacy",
    notice: "Legal notice",
    updated: "Last updated {date}",
    contents: "On this page",
    languageNote:
      "This text is also published in Spanish. If the two versions differ, this English text prevails.",
  },
  terms: TERMS_EN,
  privacy: PRIVACY_EN,
  notice: NOTICE_EN,
};
